<template>
    <div class="af-what-is-this afu-flex afu-items-center afu-text-gray-800">
        <div
            v-if="$slots"
            class="afu-text-sm"
        >
            <slot>What is this</slot>
        </div>

        <div class="afu-ml-1 afu-text-sm afu-leading-none">
            <svg
                class="afu-h-4 afu-w-4"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>

        <div
            id="template"
            style="display: none;"
        >
            <slot name="content">
                <div class="p-2">
                    <div class="afu-text-xs afu-font-semibold">
                        {{ primaryText }}
                    </div>

                    <div class="afu-text-gray-500 afu-text-xs afu-leading-loose">
                        {{ secondaryText }}
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    import 'tippy.js/themes/light.css';

    export default {
        name: 'C1WhatIsThis',

        props: {
            primaryText: {
                type: String,
                default: 'Primary text',
            },

            secondaryText: {
                type: String,
                default: '',
            },
        },

        mounted() {
            const template = this.$el.querySelector('#template');
            template.style.display = 'block';

            tippy(this.$el, {
                content: template,
                theme: 'light',
                allowHTML: true,
                placement: 'auto',
                interactive: true,
                maxWidth: 420,
            });
        },
    };
</script>
